export default __webpack_public_path__ + "static/launch-partner_HanDAO_left@2x-68b1f5932e052cafad138351c472500c.jpg";